import React, { useState } from 'react'
import { Route, Switch } from 'react-router-dom'
import { Breadcrumb, Container, ListNav } from '../../components'
import { useInternationalization } from '../../features/i18n'
import { useViewport } from '../../utils'
import { DashboardResourceForm } from '../dashboard-resources-form'
import { FormVisibility, PageHeaderDesktop } from './components'
import { MainContent } from './components/main-content.v1'
import DashboardResourceUpdate from './update'

const DashboardResources = () => {
  const { translate } = useInternationalization()
  const tabs = [
    'Field Resource',
    translate('DASHBOARD', 'visibility_settings'),
  ]
  const [activeTab, setActiveTab] = useState(tabs[0])
  const { isDesktop } = useViewport()

  const routes = [
    {
      name: translate('NAVIGATION', 'dashboard'),
      route: '/dashboard'
    },
    {
      name: translate('RESOURCE', 'our'),
      route: '/dashboard/resources'
    },
  ]

  return (
    <Switch>
      <Route
        path="/dashboard/resources/create"
        render={(props) => (
          isDesktop ? <>
            <div>
              <Breadcrumb routes={routes}/>
              <h1 className="text-4xl font-bold font-primary">
                {translate('RESOURCE', 'create')}
              </h1>
              <hr className="mt-5 mb-8"/>
            </div>
            <DashboardResourceForm {...props}/>
          </> : <>
            <Container>
              <DashboardResourceForm {...props}/>
            </Container>
          </>
        )}
      />
      <Route
        path="/dashboard/resources/edit/:id"
        render={(props) => (
          isDesktop ? <>
            <div>
              <Breadcrumb routes={routes}/>
              <h1 className="text-4xl font-bold font-primary">
                Edit {translate('RESOURCE', 'singular')}
              </h1>
              <hr className="mt-5 mb-8"/>
              <ListNav tabs={tabs} activeTab={activeTab} onChange={(e) => setActiveTab(e)}/>
            </div>
            {
              activeTab === tabs[0] &&
              <DashboardResourceUpdate {...props}/>
            }
            {
              activeTab === tabs[1] &&
              <FormVisibility />
            }
          </> : <>
            <ListNav tabs={tabs} activeTab={activeTab} onChange={(e) => setActiveTab(e)}/>
            <Container>
              {
                activeTab === tabs[0] &&
                <DashboardResourceUpdate {...props}/>
              }
              {
                activeTab === tabs[1] &&
                <FormVisibility />
              }
            </Container>
          </>
        )}
      />
      <Route path="/dashboard/resources" exact>
        { isDesktop && <PageHeaderDesktop /> }
        { isDesktop && <MainContent /> }
        { !isDesktop &&
          <Container className="py-5">
            <MainContent />
          </Container>
        }
      </Route>
    </Switch>
  )
}

export { DashboardResources }
